import { qs, on } from '../utils/dom';
import { gsap, SplitText } from '../utils/gsap';


export function menuScroll() {
  window.addEventListener('scroll', function() {
    if (window.scrollY >= 90) {
      document.querySelector('.header--logo').classList.add('is-scroll');
    } else {
      document.querySelector('.header--logo').classList.remove('is-scroll');
    }
  });
}

export function MenuAppear(isOpen) {
  let menuTl = null;
  let splitMenu = null;
  let splitSocials = null;
  let splitMenuText = null;

  const menuSelector = ".header--menu > .menu li";
  const socialsSelector = "ul.header--socials > li";
  const textMenu = ".header--content";

  if (menuTl) {
    menuTl.kill();
    menuTl = null;
  }

  if (!isOpen) {
    if (splitMenu) { splitMenu.revert(); splitMenu = null; }
    if (splitSocials) { splitSocials.revert(); splitSocials = null; }
    if (splitMenuText) { splitMenuText.revert(); splitMenuText = null; }
    gsap.set([menuSelector, socialsSelector, textMenu], { clearProps: "all" });
    return;
  }

  splitMenu = new SplitText(menuSelector, { type: "lines" });
  splitSocials = new SplitText(socialsSelector, { type: "lines" });
  splitMenuText = new SplitText(textMenu, {type: "lines"})

  menuTl = gsap.timeline({ defaults: { duration: 1.3, x: -1000, autoAlpha: 0 } });
  menuTl.from(splitMenu.lines, { stagger: 0.1 }, 0);
  menuTl.from(splitSocials.lines, { stagger: 0.1 }, 0.15);
  menuTl.from(splitMenuText.lines, {stagger: .1}, .15)
}

export function closeMenu() {
  const btn = document.querySelector('.header--menu-hamburger .hamburger');
  const headerFull = document.querySelector('.header--full');

  if (!btn || !headerFull) return;

  btn.classList.remove('is-active');
  headerFull.classList.remove('is-active');
}